<template>
	<div class="drawer-links">
		<div class="title-container">
			<div class="title">Actions</div>
			<div class="buttons">
				<a href @click.prevent="close" class="button"><div class="hover-title">Close</div><span class="fa fa-times"></span></a>
			</div>
		</div>
		<trigger-button v-for="trigger in triggers" :key="`${ module.id }-row-${ row.id }-trigger-${ trigger.id }`" :trigger="trigger" :module="module" :row="row" link-type="link"></trigger-button>
	</div>
</template>

<script>

import { DRAWERS } from '@/constants';
import TriggerButton from '@/views/components/TriggerButton';

export default {

	props: [ 'module', 'row' ],

	computed: {

		triggers() {
			return this.module.triggers;
		},

	},

	methods: {

		close() {
			this.$root.$emit('close-drawer', DRAWERS.LIST_TRIGGERS);
		},

	},

	components: {
		TriggerButton,
	},
};

</script>
